import { CreatorsListUser } from 'lib/types/users';
import { CreatorRow } from 'components/CreatorRow';
import { FeaturedTag } from 'components/FeaturedTag';

interface Props {
  creators: CreatorsListUser[];
  onListsUpdated?: () => void;
}

const toolTipTitle = 'As a Gondola PRO, you will be randomly featured at the top of creator search when you match the search criteria';

export const FeaturedCreators = ({
  creators,
  onListsUpdated,
}: Props) => {
  if (!creators) {
    return <div />;
  }

  return (
    <div className="relative border-paleyellow border-4 rounded-lg pt-2">
      <div className="absolute -right-1 -top-4">
        <FeaturedTag
          title={toolTipTitle}
          upgradeTitle="Gondola creators with PRO accounts that match your criteria are featured at the top of search results. Sign up for PRO to join them!"
        />
      </div>
      {creators.map((c) => (
        <div key={c.id} className="border-b last:border-0">
          <CreatorRow user={c} context="creator-search-featured" onListsUpdated={onListsUpdated} />
        </div>
      ))}
    </div>
  );
};
